export function isDemoUser(user) {
  if (!user) return false;
  const email = (user.email || '').toLowerCase().trim();
  return email === 'demo@sdcorner.com' || email === 'demouser@sdcorner.com';
}
